import React, { useEffect, useRef, useState } from 'react'
import NavHome from '../../components/navHome/NavHome'
import Waves from '../../components/waves/Waves'
import "./words.scss"
import {words,LngToNum} from "../../content"
import useSound from 'use-sound'
import ding from "../../sounds/ding.mp3"
import timeSound from "../../sounds/time.mp3"
import Music from '../../components/music/Music'
import Back from '../../components/back/Back'
import {useTranslation} from  'react-i18next'
import Time from '../../components/time/Time'

export default function Words() {

    const {t} = useTranslation(["common"]);
    const [play] = useSound(ding)
    const [volume] = useState(0.35);
    const [playTime] = useSound(timeSound,{volume});
    const [isActive,setIsActive] = useState(false);
    const [secondsLeft,setSecondsLeft] = useState(60);
    const [word,setWord] = useState(t("Ready"))
    const [conclude,setConclude] =useState(false);

    const secondsLeftRef = useRef(secondsLeft);
    const isActiveRef = useRef(isActive);

    function tick(){
        secondsLeftRef.current--;
        setSecondsLeft(secondsLeftRef.current)
    }

    function reset(){
        setSecondsLeft(60);
        secondsLeftRef.current=60;
        setIsActive(false)
        setWord(t("Ready"))
    }

    useEffect(()=>{
        let interval = null;
        if (isActive){
             interval = setInterval(() => {
                if (secondsLeftRef.current % 10 === 0)
                {
                    if(secondsLeftRef.current !== 0){
                        const rnd = Math.floor(Math.random() * 107)
                        const lng = LngToNum(localStorage.getItem("i18nextLng"))
                        setWord(words[lng][rnd]);
                        
                    } else {
                        setWord(t("IsOver"))
                         play();}
                }
                if (secondsLeftRef.current === 10){
                    playTime()
                }
                if (secondsLeftRef.current<=10 ){
                    setConclude(true)

                }
                if (secondsLeftRef.current<8){
                    setConclude(false)
                }
                if (secondsLeftRef.current !==0)
                    tick();
                else return setIsActive(false)
              },1000);

        } else clearInterval(interval);

        return () => clearInterval(interval);
        //eslint-disable-next-line react-hooks/exhaustive-deps
      }, [isActive]);

      const minutes = Math.floor(secondsLeft / 60);
      let seconds = secondsLeft % 60;
      if(seconds < 10) seconds = '0'+ seconds;

  return (
    <div className='word'>
        <Music/>
        <Back />
        <NavHome/>
        {conclude&&
        <Time/>
        }

        <div className="stuff">
            <p className='timer'>{`${minutes}:${seconds}`}</p>
            <h2 className='wordRND'>{word}</h2>
            <div className="buttons">
            {!isActive?
                (<div>
                {secondsLeftRef.current !==0 &&
                <div className="btn">
                    <button className='start  ' onClick={() => { setIsActive(true); isActiveRef.current = true; }}>
                        <span>{t("BtnStart")}</span>
                        <div className="liquid"></div>
                    </button>
                </div>}

                {secondsLeftRef.current !== 60 &&
                     <div className="btn">
                        <button className='restart ani' onClick={reset}>
                            <span>{t("BtnRestart")}</span>
                            <div className="liquid"></div>
                        </button>
                    </div>
                }
                </div>)
            :
                <div className="btn">
                          <button className='start '  onClick={() => { setIsActive(false); isActiveRef.current = false; } }>
                              <span>{t("BtnPause")}</span>
                              <div className="liquid"></div>
                          </button>
                      </div>
            }

            </div>
        </div>
        <Waves/>
    </div>
  )
}
